import { Capacitor } from '@capacitor/core';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { Camera } from '@capacitor/camera';
import { Filesystem } from '@capacitor/filesystem';
import { Purchases } from '@revenuecat/purchases-capacitor';

// Attach Capacitor and Plugins to the global window object
// so our vanilla JS files (like v2-auth.js) can use them.
window.Capacitor = Capacitor;
window.CapacitorPlugins = {
  FirebaseAuthentication,
  Camera,
  Filesystem,
  Purchases,
};
